import { doc, p } from '@atlaskit/adf-utils/builders';

export const EMPTY_FALLBACK_MESSAGE = JSON.stringify(doc(p('')));

// eslint-disable-next-line prefer-const
export let APP_CONTEXT: {
    cloudId: string;
    orgId: string;
    fallbackMessage: string;
} = {
    cloudId: '',
    orgId: '',
    fallbackMessage: EMPTY_FALLBACK_MESSAGE,
};
